import React from 'react';
import styles from '../css/vdr.module.css';

/** Readers from Document.read_by joined to the project user list. */
const ReadersPanel = ({ fileName, readers = [] }) => {
    const count = readers.length;

    return (
        <div>
            <h3 className={styles.fileName} style={{ marginBottom: 4 }}>
                File readers
            </h3>
            {fileName ? <p className={styles.subMeta}>{fileName}</p> : null}
            <p className={styles.subMeta} style={{ marginBottom: 16 }}>
                {count} reader{count === 1 ? '' : 's'}
            </p>
            <div className={styles.readersHead}>
                <span>Reader</span>
                <span>Access group</span>
                <span>Last read</span>
            </div>
            {readers.map(reader => (
                <div key={reader.id} className={styles.readersRow}>
                    <span className={styles.readersName}>{reader.name}</span>
                    <span className={styles.readersMeta}>{reader.accessGroup || '—'}</span>
                    <span className={styles.readersMeta}>{reader.lastRead || '—'}</span>
                </div>
            ))}
            {count === 0 ? <p className={styles.subMeta}>No readers yet</p> : null}
        </div>
    );
};

export default ReadersPanel;
